import type { SimulationInput } from '../../api/types'

export type FieldKey = Exclude<
  keyof SimulationInput,
  'name' | 'address' | 'surface' | 'loanDurationYears'
>

export interface Field {
  key: FieldKey
  label: string
  unit: '€' | '%' | 'mois'
}

export const acquisitionFields: Field[] = [
  { key: 'purchasePrice', label: "Prix d'achat", unit: '€' },
  { key: 'compromis', label: 'Compromis', unit: '€' },
  { key: 'notaryFeeRate', label: 'Taux frais de notaire', unit: '%' },
  { key: 'renovationCosts', label: 'Montant des travaux', unit: '€' },
]

export const financementFields: Field[] = [
  { key: 'loanPrincipal', label: 'Montant du prêt', unit: '€' },
  { key: 'loanRate', label: "Taux d'intérêt", unit: '%' },
]

export const rentabiliteLocativeFields: Field[] = [
  { key: 'monthlyRent', label: 'Montant du loyer', unit: '€' },
  { key: 'monthlyPropertyTax', label: 'Taxe foncière / mois', unit: '€' },
  { key: 'monthlyCondoFees', label: 'Charges copro / mois', unit: '€' },
  { key: 'monthlyInsurancePno', label: 'Assurance PNO / mois', unit: '€' },
  { key: 'monthlyManagementFee', label: 'Frais de gestion / mois', unit: '€' },
]

export const rentabiliteReventeFields: Field[] = [
  { key: 'pricePerM2Resale', label: 'Prix du m² revente', unit: '€' },
  { key: 'holdingMonths', label: 'Durée de détention', unit: 'mois' },
  { key: 'resaleFees', label: 'Remboursement prêt anticipé', unit: '€' },
]
